import React from 'react';
import './Gallery.css';
// import { project1, project2, ... } from '../assets/images/gallery';

function Gallery() {
  // Quando adicionar imagens, use: src: project1
  const images = [
    { id: 1, title: 'Projeto 1', src: null },
    { id: 2, title: 'Projeto 2', src: null },
    { id: 3, title: 'Projeto 3', src: null },
    { id: 4, title: 'Projeto 4', src: null },
    { id: 5, title: 'Projeto 5', src: null },
    { id: 6, title: 'Projeto 6', src: null },
    { id: 7, title: 'Projeto 7', src: null },
    { id: 8, title: 'Projeto 8', src: null },
    { id: 9, title: 'Projeto 9', src: null }
  ];

  return (
    <section className="gallery-section" id="galeria">
      <h2>GALERIA</h2>
      <p className="gallery-description">
        Nosso portfólio reflete a diversidade e a qualidade dos projetos desenvolvidos pela Edifica 3D. Cada peça apresentada representa um processo cuidadoso de criação, desde a ideia inicial até a impressão final, sempre com foco em funcionalidade, estética e precisão. Atuamos em diferentes frentes, como peças utilitárias, projetos personalizados, soluções corporativas, brindes e itens decorativos, incluindo action figures e produtos exclusivos. Mais do que mostrar resultados, nosso portfólio demonstra nosso compromisso em transformar ideias em estruturas bem construídas, duráveis e feitas com propósito.
      </p>
      <div className="gallery-grid">
        {images.map((image) => (
          <div 
            key={image.id} 
            className="gallery-item"
            style={image.src ? { backgroundImage: `url(${image.src})` } : {}}
          >
            <div className="gallery-overlay">
              <span>{image.title}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;
